import { StrapiMedia } from "@/components/shared/StrapiMedia";
import { useGameEndData } from "@/state/cacheStoreHooks";
import { StrapiAsset } from "@/types/api";

type Props = {
    roomImage: StrapiAsset;
};

const Polaroid = ({ roomImage }: Props) => {
    const gameEndData = useGameEndData();

    const itemImageA = gameEndData?.polaroidItemA;
    const itemImageB = gameEndData?.polaroidItemB;

    return (
        <div className="size-full flex flex-grow items-center justify-center overflow-hidden px-2 pt-2">
            {/* polaroid */}
            <div className="@container relative aspect-[145/213] h-[80%] bg-white -rotate-[4deg] rounded-[3px] border-[1px] border-secondary-500 flex flex-col emboss-shadow">
                {itemImageA && (
                    <div className="absolute z-20 w-[68%] -left-[33%] bottom-[17%]">
                        <StrapiMedia size="md" image={itemImageA} objectFit="contain" className="w-full h-auto" />
                    </div>
                )}
                {itemImageB && (
                    <div className="absolute z-20 w-[42%] -right-[17%] -top-[16%]">
                        <StrapiMedia size="md" image={itemImageB} objectFit="contain" className="w-full h-auto" />
                    </div>
                )}
                <div className="flex flex-col flex-1 min-h-0 m-[7%] gap-[3%]">
                    <div className="relative flex-1 min-h-0 overflow-hidden">
                        <StrapiMedia
                            size="lg"
                            image={roomImage}
                            objectFit="cover"
                            className="absolute inset-0 object-cover w-full h-full rounded-[3px]"
                        />
                    </div>
                    <svg viewBox="0 0 100 20" className="w-full h-[10%]">
                        <text
                            x="50"
                            y="18"
                            textAnchor="middle"
                            className="font-handwriting fill-black tracking-tighter"
                            fontSize="18"
                        >
                            Meine Wohnung :)
                        </text>
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default Polaroid;